import { createApi } from '@reduxjs/toolkit/query/react'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const adPricingApiService = createApi({
  reducerPath: 'adPricingApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/ad-pricing/'),
  tagTypes: ['AdPricing'],
  endpoints: (builder) => ({
    // Get current ad pricing config
    getAdPricing: builder.query({
      query: () => ({
        url: 'admin',
        method: 'GET'
      }),
      providesTags: ['AdPricing'],
      keepUnusedDataFor: 0
    }),
    // Update ad pricing
    updateAdPricing: builder.mutation({
      query: (data) => ({
        url: 'admin/update',
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['AdPricing']
    }),
  })
})

export const {
  useGetAdPricingQuery,
  useUpdateAdPricingMutation
} = adPricingApiService

